import { useState } from 'react';

const NAV = [
  { label: '在追事件', href: '#watch' },
  { label: '最新进展', href: '#feed' },
  { label: '当事人回应', href: '#response' },
  { label: '话题墙', href: '#topics' },
  { label: '反转观察', href: '#reversal' },
  { label: '常见问题', href: '#faq' },
];

export default function Header() {
  const [open, setOpen] = useState(false);

  return (
    <div className="relative z-50">
      {/* ticker operations strip */}
      <div className="bg-primary-950 text-background-100/85">
        <div className="mx-auto flex max-w-7xl items-center gap-3 px-4 py-2 text-xs md:px-6">
          <div className="flex shrink-0 items-center gap-2">
            <span className="live-dot h-2 w-2 rounded-full bg-accent-500" />
            <span className="font-label font-medium tracking-wide text-accent-300">LIVE · 频道更新中</span>
          </div>
          <p className="hidden min-w-0 flex-1 truncate sm:block">
            正在跟进 <span className="font-semibold text-background-50">6</span> 起在线黑料事件 · 最近一次更新于 2 分钟前 · 当事人二度回应已收录
          </p>
          <p className="ml-auto whitespace-nowrap font-label text-background-100/70 sm:ml-0">
            累计跟踪报道 <span className="font-semibold text-background-50">128</span> 篇
          </p>
        </div>
      </div>

      {/* main nav */}
      <header className="sticky top-0 border-b border-background-200 bg-background-50/85 backdrop-blur">
        <div className="mx-auto flex max-w-7xl items-center gap-4 px-4 py-3 md:px-6">
          <h1 className="flex items-center gap-2 whitespace-nowrap">
            <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-900 text-background-50">
              <i className="ri-eye-line text-base" />
            </span>
            <span className="font-heading text-lg font-bold tracking-tight text-foreground-950">在线黑料</span>
          </h1>

          <nav className="hidden flex-1 items-center justify-center gap-1 lg:flex">
            {NAV.map((item) => (
              <a
                key={item.href}
                href={item.href}
                className="whitespace-nowrap rounded-md px-3 py-2 text-sm text-foreground-700 transition-colors hover:bg-background-100 hover:text-foreground-950"
              >
                {item.label}
              </a>
            ))}
          </nav>

          <div className="ml-auto flex items-center gap-2 lg:ml-0">
            <div className="hidden items-center gap-2 rounded-md border border-background-200 bg-background-100 px-3 py-1.5 text-foreground-500 md:flex">
              <i className="ri-search-line text-sm" />
              <span className="text-xs">搜索话题 / 当事人</span>
            </div>
            <a
              href="#faq"
              className="flex items-center gap-1.5 whitespace-nowrap rounded-md bg-accent-500 px-3 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-accent-600"
            >
              <i className="ri-notification-3-line text-sm" />
              <span className="hidden sm:inline">关注不迷路</span>
              <span className="sm:hidden">关注</span>
            </a>
            <button
              type="button"
              aria-label="菜单"
              onClick={() => setOpen((v) => !v)}
              className="flex h-9 w-9 items-center justify-center rounded-md border border-background-200 text-foreground-800 lg:hidden"
            >
              <i className={`${open ? 'ri-close-line' : 'ri-menu-line'} text-lg`} />
            </button>
          </div>
        </div>

        {open && (
          <nav className="border-t border-background-200 bg-background-50 px-4 py-3 lg:hidden">
            <div className="grid grid-cols-2 gap-1 sm:grid-cols-3">
              {NAV.map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  onClick={() => setOpen(false)}
                  className="rounded-md px-3 py-2 text-sm text-foreground-700 hover:bg-background-100"
                >
                  {item.label}
                </a>
              ))}
            </div>
          </nav>
        )}
      </header>
    </div>
  );
}